import * as React from 'react';

import './style.css';
import { Link } from 'react-router-dom';

export default function SelectBox({elements=[], hidden=false, onSelect=()=>{}}){
    console.log("ELEMENTS", elements)
    return (
        <div hidden={hidden} className="select-box-wrap">
        <div className="select-box-transparent">
            <div className="select-box-drop">
                {
                    elements.map((city,key) =>{
                        return (
                            <div className="select-box-element" onMouseDown={onSelect} key={key}>
                                {city['text']}
                            </div>
                               )
                    })
                }
            </div>
        </div>
        </div>
    )

}